import { useLang } from '@/i18n';
import EcoSpace from 'eco-design/base/eco-space';
import EcoSpaceSmall from 'eco-design/base/eco-space-small';
import EcoSectionCommon from 'eco-design/elements/eco-section-common';
import EcoCardsB from 'eco-design/sections-test/eco-cards-b';
import EcoShopCardA from 'eco-design/sections-test/eco-shop-card-a';
import styles from './index.module.scss';
import { useProductStore } from '@elem/compPage/wave-3-and-glacier-classic/ProductProvider';
import { IPageStatus } from '@elem/compPage/wave-3-and-glacier-classic/config/IPageStatus';
export default function Comp() {
    const { t } = useLang('theProduct.ListB1');
    const { pageStatus } = useProductStore();
    const itemsA = [
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1745206576827/KV.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1745206749280/KV.jpg',
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1745373182398/image%20(1).jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1745206750154/Frame%201612707471.jpg',
            desc: t('item1_desc1'),
            title: t('item1_title'),
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1745373183379/image.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1745206749969/Frame%201612707470.jpg',
            desc: t('item2_desc1'),
            title: t('item2_title'),
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1745373183089/image%20(5).jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1745206749161/image.jpg',
            desc: t('item3_desc1'),
            title: t('item3_title'),
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1745373182556/image%20(3).jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1745206749510/app-%E6%91%84%E6%B0%8F%E5%BA%A6.jpg',
            desc: t('item4_desc1'),
            title: t('item4_title'),
        },
    ];

    return (
        <div className={styles.comp}>
            <EcoSpace />
            <EcoSectionCommon title={t('title')} desc={t('desc')} />
            <EcoSpaceSmall />
            <EcoCardsB items={itemsA} />
            <div className={`eco-content`}>
                <EcoShopCardA
                    layout="imgR"
                    pc="https://websiteoss.ecoflow.com/upload/image/1745204809677/WAVE%203.png"
                    label={pageStatus === IPageStatus.statusA || pageStatus === IPageStatus.statusB ? t('card_label') : undefined}
                    title={t('card_title')}
                    desc={[t('card_desc1'), t('card_desc2'), t('card_desc3'), t('card_desc4')]}
                    lChildren={pageStatus === IPageStatus.statusA || pageStatus === IPageStatus.statusB ? t('card_btn') : t('card_btn2')}
                    lHref={
                        pageStatus === IPageStatus.statusA || pageStatus === IPageStatus.statusB
                            ? '#ActivityA3'
                            : 'https://www.ecoflow.com/jp/wave-3-portable-air-conditioner'
                    }
                    ldataLayer={{
                        event: 'uaEvent',
                        event_name: 'buy',
                        product_name: t('card_title'),
                        position: `Collections_${t('card_title')}`,
                    }}
                />
            </div>
        </div>
    );
}
